import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const stats = {
  path: '/stats',
  redirect: '/stats/mobileROI',
  component: Layout,
  name: 'dashStats',
  meta: {
    title: 'Statistiques',        // pour le fil d'Arianne
    icon: 'mdi:poll',
    permissions: [P.MISC.BROWSE_STATS],
  },

  children: [
    {
      path: '/stats/mobileROI',
      component: () => import('@/views/stats/MobileStats.vue'),
      meta: {
        title: 'Mobile',
        permissions: [P.MISC.BROWSE_STATS],
        icon: 'mdi:cellphone-check',
        noCache: true,
      },
    },
    {
      path: '/stats/ECampaign',
      component: () => import('@/views/stats/ECampStatsWidget.vue'),
      meta: {
        title: 'eCampaign',
        permissions: [P.MISC.BROWSE_STATS],
        icon: 'mdi:send-outline',
        noCache: true,
      },
    },
  ],
}

export default stats
